import { bindActionCreators } from '@reduxjs/toolkit';
import initStore from './init-store';

import { default as APIAuth } from './api-auth';
import { default as UserInfo } from './user-info';
import { default as USERSList } from './users';
import { default as User } from './user';
import { default as UserInfoToModify } from './user-info-to-modify';
import { default as ResetPassword } from './reset-password';
import { default as Circulations } from './circulations';
import { default as Stations } from './stations';
import { default as StationsServed } from './stations-served';
import { default as Reasons } from './reasons';
import { default as ProductCodes } from './product-codes';
import { default as HelpInfos } from './help-infos';
import { default as HelpInfo } from './help-info';
import { default as Reason } from './reason';
import { default as ProductCode } from './product-code';
// Communication ------------------------------------------------------------------------------------------
import { default as StationsTemplatesPreview } from './stations-templates-preview';
import { default as HistoricCommunication } from './historic-communication';
import { default as HistoricPendingCommunication } from './historic-pending-communication';
import { default as ServicesPassengersConcernedByCommunication } from './communication-impacted-passengers';
import { default as LatestCommunication } from './latest-communication';
import { default as SendCommunication } from './send-communication';
// ---------------------------------------------------------------------------------------------------------
import { default as CustomersList } from './customers-list';
import { default as ApiVersion } from './api-version';
import { default as Situations } from './situations';
import { default as SituationsCommunications } from './situations-communications';
import { default as SituationsCategory } from './situations-category';
import { default as SituationCategory } from './situation-category';
import { default as Situation } from './situation';
import { default as Masks } from './masks';
import { default as Mask } from './mask';
import { default as MasksConfig } from './masks-config';
import { default as profiles } from './profiles';
import { default as groups } from './groups';
import { default as OtherSelection } from './other-selection';
import { default as Typology } from './typology';
import { default as CompensationSentences } from './compensation-sentences';
import { default as CompensationSentence } from './compensation-sentence';
import { default as MessagesMasks } from './messages-mask';
import { default as Profil } from './profil';
import { default as Sections } from './sections';
import { default as Keywords } from './keywords';
import { default as SendStatus } from './send-status';
import { default as ServiceTypes } from './service-types';
import { default as TranslationLanguages } from './translation-languages';

// Clear State Slice
import { default as ClearStateSlice } from './clear-slice';

/* slices */
export default {
  bindActionCreators,
  initStore,
  // export capitalized are Redux Slices
  APIAuth,
  UserInfo,
  USERSList,
  User,
  UserInfoToModify,
  ResetPassword,
  Circulations,
  Stations,
  StationsServed,
  Reasons,
  ProductCodes,
  HelpInfos,
  HelpInfo,
  Reason,
  ProductCode,
  // Communication ---------------------------
  StationsTemplatesPreview,
  HistoricCommunication,
  HistoricPendingCommunication,
  ServicesPassengersConcernedByCommunication,
  LatestCommunication,
  SendCommunication,
  // -----------------------------------------
  CustomersList,
  ApiVersion,
  Situations,
  SituationsCommunications,
  SituationsCategory,
  SituationCategory,
  Situation,
  Masks,
  Mask,
  MasksConfig,
  profiles,
  groups,
  OtherSelection,
  Typology,
  CompensationSentences,
  CompensationSentence,
  MessagesMasks,
  Profil,
  Sections,
  Keywords,
  SendStatus,
  ServiceTypes,
  TranslationLanguages,

  // Clear State Slice
  ClearStateSlice,
};
